import { Link } from 'react-router-dom'

const iconCls = 'h-[18px] w-[18px]'

function PencilIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={iconCls}>
      <path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 12.5-12.5z" />
    </svg>
  )
}

function DocIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={iconCls}>
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </svg>
  )
}

/** Ícones de ação: editar (abre popup) e abrir relatório. */
export function ActionIcons({ reportId, onEdit }: { reportId: string; onEdit: () => void }) {
  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={onEdit}
        title="Editar status / comentário"
        aria-label="Editar status / comentário"
        className="rounded-md p-1 text-slate-400 transition hover:bg-slate-100 hover:text-brand-600"
      >
        <PencilIcon />
      </button>
      <Link
        to={`/reports/${reportId}`}
        title="Abrir relatório"
        aria-label="Abrir relatório"
        className="rounded-md p-1 text-slate-400 transition hover:bg-slate-100 hover:text-brand-600"
      >
        <DocIcon />
      </Link>
    </div>
  )
}
